<template>
  <div>
    <!-- <div v-if="!selectedUserType">
      <UserTypeSelector @selected="handleUserTypeSelection" />
    </div> -->
    <div>
      <div class="registration-container">
        <!-- Loading général -->
        <div v-if="isLoaderActive" class="loading">
          <div class="loading-box">
            <div class="spinner"></div>
            <div class="loading-content">
              <p class="loading-title">Inscription en cours</p>
              <p class="loading-subtitle">
                Veuillez patienter, cela peut prendre quelques instants.
              </p>
              <div class="progress-container">
                <div class="progress-bar" :style="{ width: progressBar + '%' }">
                  <div class="progress-label">{{ progressBar }}%</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Logo -->
        <div class="logo-section">
          <a href="https://symbiocenter.fr/" target="_blank">
            <img
              src="../../assets/img/Logos_Symbiofi_SymbioCenter_PRO_vectoriser.png"
              alt="Logo Symbiofi"
              class="logo"
            />
          </a>
        </div>

        <!-- Titre -->
        <div class="title-section">
          <h1 class="main-title">
            {{ $t("Formulaire de souscription au SymbioCenter") }}
          </h1>
          <h2 class="subtitle">Offre réservée aux professionnels</h2>
        </div>

        <!-- Contenu principal -->
        <div class="form-section" v-if="!hasSubscription">
          <form @submit.prevent="InscriptionMethod" class="form">
            <!-- Nom -->
            <div class="input-group">
              <input
                class="input"
                :class="{ error: !user.nom && error }"
                type="text"
                placeholder="Nom de famille"
                v-model="user.nom"
              />
              <div class="error-msg" v-if="!user.nom && error">
                Veuillez saisir votre nom de famille
              </div>
            </div>

            <!-- Prénom -->
            <div class="input-group">
              <input
                class="input"
                :class="{ error: !user.prenom && error }"
                type="text"
                placeholder="Prénom"
                v-model="user.prenom"
              />
              <div class="error-msg" v-if="!user.prenom && error">
                Veuillez saisir votre prénom
              </div>
            </div>

            <!-- Profession -->
            <div class="input-group">
              <input
                class="input"
                :class="{ error: !user.profession && error }"
                type="text"
                placeholder="Profession"
                v-model="user.profession"
              />
              <div class="error-msg" v-if="!user.profession && error">
                Veuillez saisir votre profession
              </div>
            </div>

            <!-- Téléphone -->
            <div class="input-group">
              <input
                class="input"
                :class="{ error: !user.telephone_pro && error }"
                type="tel"
                placeholder="Téléphone professionnel"
                v-model="user.telephone_pro"
              />
              <div class="error-msg" v-if="!user.telephone_pro && error">
                Veuillez saisir votre téléphone professionnel
              </div>
            </div>

            <!-- Email -->
            <div class="input-group">
              <input
                class="input"
                :class="{
                  error:
                    (!user.mail && error) ||
                    errorEmailFormat ||
                    errorEmailUse ||
                    errorMajuscule,
                }"
                type="email"
                placeholder="Email professionnel"
                v-model="user.mail"
              />
              <div class="error-msg" v-if="!user.mail && error">
                Veuillez saisir votre email professionnel
              </div>
              <div class="error-msg" v-if="errorEmailFormat">
                Format de l'email incorrect
              </div>
              <div class="error-msg" v-if="errorEmailUse">
                Email déjà utilisé
              </div>
              <div class="error-msg" v-if="errorMajuscule">
                L'email ne doit pas contenir de majuscule
              </div>
            </div>

            <!-- Mot de passe -->
            <div class="input-group">
              <div class="password-wrapper">
                <input
                  class="input"
                  :class="{
                    error:
                      (isntSamePassword ||
                        !hasMajuscule ||
                        !hasSpecialCharacter ||
                        !hasGoodLength) &&
                      error,
                  }"
                  :type="showPassword ? 'text' : 'password'"
                  placeholder="Mot de passe"
                  v-model="user.password"
                />
                <button
                  type="button"
                  class="password-toggle"
                  @click="showPassword = !showPassword"
                >
                  <i
                    :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                  ></i>
                </button>
              </div>
              <!-- Affiche les exigences UNIQUEMENT si au moins UNE n'est pas respectée -->
              <div
                class="password-requirements"
                v-if="
                  user.password &&
                  (!hasGoodLength || !hasMajuscule || !hasSpecialCharacter)
                "
              >
                <div class="requirement" v-if="!hasGoodLength">
                  <i class="fas fa-times"></i>
                  Au moins 8 caractères
                </div>
                <div class="requirement" v-if="!hasMajuscule">
                  <i class="fas fa-times"></i>
                  Une majuscule
                </div>
                <div class="requirement" v-if="!hasSpecialCharacter">
                  <i class="fas fa-times"></i>
                  Un chiffre
                </div>
              </div>
            </div>

            <!-- Confirmation mot de passe -->
            <div class="input-group">
              <div class="password-wrapper">
                <input
                  class="input"
                  :class="{ error: isntSamePassword }"
                  :type="showConfirmPassword ? 'text' : 'password'"
                  placeholder="Confirmer le mot de passe"
                  v-model="user.confirmPassword"
                />
                <button
                  type="button"
                  class="password-toggle"
                  @click="showConfirmPassword = !showConfirmPassword"
                >
                  <i
                    :class="
                      showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'
                    "
                  ></i>
                </button>
              </div>
              <div
                class="error-msg"
                v-if="user.confirmPassword && isntSamePassword"
              >
                Les mots de passe ne correspondent pas
              </div>
            </div>

            <!-- CGU -->
            <div class="checkbox-group">
              <label class="checkbox-label">
                <input type="checkbox" v-model="cgu" class="checkbox" />
                <span class="checkmark"></span>
                <span class="checkbox-text">
                  {{ $t("cgu2") }}
                  (<a
                    href="https://www.symbiocenter.com/assets/CGU_P_SymbioCenter.pdf"
                    target="_blank"
                    class="link"
                  >
                    {{ $t("cgu2_cgu") }} </a
                  >,
                  <a
                    href="https://www.symbiocenter.com/assets/RGPD_SymbioCenter.pdf"
                    target="_blank"
                    class="link"
                  >
                    {{ $t("cgu2_rgpd") }} </a
                  >)
                </span>
              </label>
              <div class="error-msg" v-if="errorCgu">
                {{ $t("erreurCgu2") }}
              </div>
            </div>

            <!-- Bouton -->
            <button
              type="submit"
              class="btn"
              :class="{ disabled: !isFormValid }"
              :disabled="!isFormValid"
            >
              {{ $t("demandeDeSouscription") }}
            </button>
          </form>
        </div>

        <!-- Message de succès (si nécessaire) -->
        <div v-else class="success-section">
          <div class="success-box">
            <i class="fas fa-check-circle success-icon"></i>
            <h3>Inscription réussie !</h3>
            <p>Votre demande a été envoyée avec succès.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Parse from "parse";
import ParseConfig from "@/api/parse.config.js";
import UserService from "@/services/utilisateurs/NewCreateUser.js";
import UserTypeSelector from "@/views/inscription/UserTypeSelector.vue";

export default {
  name: "RegistrationForm",
  data() {
    return {
      isLoaderActive: false,
      progressBar: 0,
      showPassword: false,
      showConfirmPassword: false,
      user: {
        nom: "",
        prenom: "",
        profession: "",
        telephone_pro: "",
        mail: "",
        password: "",
        confirmPassword: "",
      },
      error: false,
      errorMessage: null,
      errorMajuscule: false,
      hasSubscription: false,
      errorEmailFormat: false,
      errorEmailUse: false,
      errorCgu: false,
      cgu: false,
      isStagiaire: false,
      selectedUserType: "therapeute_base",
    };
  },
  computed: {
    hasMajuscule() {
      return this.user.password.match(/[A-Z]/g);
    },
    hasSpecialCharacter() {
      return this.user.password.match(/[0-9]/g);
    },
    hasGoodLength() {
      return this.user.password.length >= 8;
    },
    isntSamePassword() {
      return (
        this.user.password !== this.user.confirmPassword &&
        this.user.confirmPassword.length > 0
      );
    },
    isFormValid() {
      return (
        this.user.nom &&
        this.user.prenom &&
        this.user.profession &&
        this.user.telephone_pro &&
        this.user.mail &&
        this.user.password &&
        this.user.confirmPassword &&
        this.hasMajuscule &&
        this.hasSpecialCharacter &&
        this.hasGoodLength &&
        !this.isntSamePassword &&
        this.cgu
      );
    },
  },
  created() {
    try {
      const urlParams = new URLSearchParams(window.location.hash.split("?")[1]);
      this.ParamInscription = urlParams.get("type_inscription");
      if (this.ParamInscription === "stagiaire") {
        this.isStagiaire = true;
      }
    } catch (error) {
      console.log(error);
    }
  },
  components: {
    UserTypeSelector,
  },
  methods: {
    async addUserInHubspot() {
      ParseConfig();
      var date = new Date();
      var formattedDate = date.toISOString().substring(0, 10);

      Parse.Cloud.run("addContactToHubSpot", {
        email: this.user.mail.trim(),
        firstname: this.user.prenom,
        lastname: this.user.nom,
        phone: this.user.telephone_pro,
        jobtitle: this.user.profession,
        date_d_inscription: formattedDate,
        offre_pulse: "Gratuit",
      })
        .then((result) => {
          console.log(result);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    handleUserTypeSelection(type) {
      this.selectedUserType = type;
    },
    async sendMail(newUser, utilisateur, objectId) {
      const results = [];

      try {
        await Parse.Cloud.run("informeCompteTherapeuteCree", {
          utilisateur: utilisateur,
          nom: newUser.nom,
          prenom: newUser.prenom,
          telephone: newUser.telephone_pro,
          typeAbonnement: "gratuit",
        });
        results.push({ email1: "success" });
      } catch (error) {
        console.error("Erreur lors de l'envoi du premier email", error);
        results.push({ email1: "failed", error: error.message });
      }

      try {
        await Parse.Cloud.run("accountValidationRequest", {
          utilisateur: utilisateur,
          nom: newUser.nom,
          objectId: objectId,
          prenom: newUser.prenom,
        });
        results.push({ email2: "success" });
      } catch (error) {
        console.error("Erreur lors de l'envoi du deuxième email", error);
        results.push({ email2: "failed", error: error.message });
      }

      return results;
    },

    async InscriptionMethod() {
      ParseConfig();
      this.error = false;
      this.errorCgu = false;
      this.errorEmailUse = false;

      try {
        if (!this.cgu) {
          this.error = true;
          this.errorCgu = true;
          return;
        }

        if (!this.isFormValid) {
          this.error = true;
          return;
        }

        // Vérifier si l'email existe déjà
        if (this.user.mail) {
          var userQuery = new Parse.Query(Parse.User);
          userQuery.equalTo("username", this.user.mail.trim());
          const userResponse = await userQuery.find();
          if (userResponse.length) {
            this.error = true;
            this.errorEmailUse = true;
            return;
          }
        }
        this.user.user_type = this.selectedUserType;

        this.isLoaderActive = true;
        const user = await UserService.createTherapeute(
          this.user,
          (progress) => {
            this.progressBar = progress;
          },
          this.isStagiaire
        );

        if (user) {
          this.sendMail(this.user, this.user.mail.trim(), user.id);
          try {
            this.addUserInHubspot();
          } catch (error) {
            console.log(error);
          }
          window.location = "/gestion#/inscription-succeed";
        }
      } catch (error) {
        console.error("Erreur lors de l'inscription", error);
        this.isLoaderActive = false;
      }
    },
  },
};
</script>

<style scoped>
.registration-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 40px 20px;
  min-height: 70vh;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
}

/* Logo */
.logo-section {
  text-align: center;
  margin-bottom: 30px;
}

.logo {
  height: 60px;
  width: auto;
}

/* Titre */
.title-section {
  text-align: center;
  margin-bottom: 40px;
}

.main-title {
  font-size: 24px;
  font-weight: 600;
  color: #239380;
  margin-bottom: 8px;
  line-height: 1.3;
}

.subtitle {
  font-size: 16px;
  color: #239380;
  font-weight: 500;
}

/* Form section */
.form-section {
  width: 100%;
}

.form {
  width: 100%;
}

/* Input groups */
.input-group {
  margin-bottom: 20px;
}

.input {
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #e5e5e5;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.2s;
}

.input:focus {
  outline: none;
  border-color: #239380;
}

.input.error {
  border-color: #f44336;
  background: #fef5f5;
}

.input::placeholder {
  color: #999;
}

/* Password wrapper */
.password-wrapper {
  position: relative;
}

.password-toggle {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  font-size: 16px;
}

.password-toggle:hover {
  color: #239380;
}

/* Password requirements */
.password-requirements {
  margin-top: 8px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  font-size: 14px;
}

.requirement {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  color: #666;
}

.requirement:last-child {
  margin-bottom: 0;
}

.requirement.valid {
  color: #28a745;
}

.requirement i {
  width: 12px;
  font-size: 12px;
}

/* Error messages */
.error-msg {
  color: #f44336;
  font-size: 14px;
  margin-top: 6px;
  padding: 8px 12px;
  background: #fef2f2;
  border-radius: 4px;
}

/* Checkbox */
.checkbox-group {
  margin-bottom: 24px;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
  line-height: 1.5;
}

.checkbox {
  display: none;
}

.checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid #e5e5e5;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
  transition: all 0.2s;
}

.checkbox:checked + .checkmark {
  background: #239380;
  border-color: #239380;
}

.checkbox:checked + .checkmark::after {
  content: "✓";
  color: white;
  font-size: 14px;
  font-weight: bold;
}

.checkbox-text {
  font-size: 14px;
  color: #333;
}

.link {
  color: #239380;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

/* Button */
.btn {
  width: 100%;
  padding: 16px;
  background: #239380;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 8px;
}

.btn:hover:not(.disabled) {
  background: #1e7a68;
  transform: translateY(-1px);
}

.btn.disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
}

/* Loading */
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.loading-box {
  background: white;
  padding: 40px;
  border-radius: 12px;
  text-align: center;
  max-width: 400px;
  width: 90%;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f0f0f0;
  border-top: 4px solid #239380;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

.loading-content {
  margin-top: 20px;
}

.loading-title {
  font-size: 18px;
  font-weight: 600;
  color: #239380;
  margin-bottom: 8px;
}

.loading-subtitle {
  color: #666;
  margin-bottom: 20px;
  line-height: 1.4;
}

/* Progress bar */
.progress-container {
  width: 100%;
  background-color: #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
  height: 20px;
  position: relative;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #239380, #1e7a68);
  transition: width 0.3s ease;
  position: relative;
}

.progress-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 12px;
  font-weight: 600;
  width: 100%;
  text-align: center;
}

/* Success section */
.success-section {
  text-align: center;
  padding: 40px 20px;
}

.success-box {
  background: #e8f5e8;
  padding: 40px;
  border-radius: 12px;
  border-left: 4px solid #28a745;
}

.success-icon {
  font-size: 48px;
  color: #28a745;
  margin-bottom: 20px;
}

.success-box h3 {
  color: #2e7d32;
  margin-bottom: 12px;
  font-size: 24px;
}

.success-box p {
  color: #2e7d32;
  font-size: 16px;
}

/* Animations */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Responsive */
@media (max-width: 480px) {
  .registration-container {
    padding: 24px 16px;
  }

  .logo {
    height: 50px;
  }

  .main-title {
    font-size: 20px;
  }

  .input,
  .btn {
    padding: 12px 14px;
  }

  .password-toggle {
    right: 14px;
  }
}
</style>
